import styled from '@emotion/styled/macro'
import { Box } from '@mui/material'
import theme from 'theme'

export const SearchBarWrapper = styled(Box)`
  display: flex;
  justify-content: center;
  padding: ${theme.spacing.xSmall}px 0;
  position: sticky;
  top: 0;
  z-index: 1;
  background: ${theme.colors.frameworkCardBg};

  .search-icon {
    position: absolute;
    top: 18px;
    left: ${theme.spacing.xSmall}px;
    z-index: 1;
    width: 24px;
    height: 24px;
    min-width: 24px;

    html[data-theme='light'] & {
      path {
        stroke: ${theme.colors.devicesSecondaryText};
        fill: ${theme.colors.devicesSecondaryText};
      }
    }
  }

  .clear-btn {
    position: absolute;
    right: ${theme.spacing.lg}px;
  }

  .search-bar {
    width: 100%;
    border-radius: ${theme.attributes.borderRadius.small};
    height: 40px;
  }

  .MuiOutlinedInput-input {
    border: 1px solid ${theme.colors.controlBorder};
    border-radius: ${theme.attributes.borderRadius.small};
    background: ${theme.colors.frameworkCardBg};
    height: 40px;
    padding: 0 50px 0 ${theme.spacing.xLarge}px;
    color: ${theme.colors.devicesSecondaryText};
    font-family: ${theme.typography.fontFamily.primary};
    font-size: ${theme.typography.fontSize.xLarge};
    font-style: normal;
    font-weight: ${theme.typography.fontWeight.normal};
    line-height: 24px;
    letter-spacing: 0.5px;

    html[data-theme='light'] & {
      border-color: ${theme.colors.dropdownBorder};
    }

    &::placeholder {
      color: ${theme.colors.caption};
      opacity: 1;

      overflow: hidden;
      text-overflow: ellipsis;
      font-size: ${theme.typography.fontSize.xLarge};
      font-style: normal;
      font-weight: ${theme.typography.fontWeight.normal};
      line-height: normal;

      html[data-theme='light'] & {
        color: ${theme.colors.devicesSecondaryText};
      }
    }

    &:focus {
      border-color: ${theme.colors.cta};
    }
  }

  fieldset {
    border: none;
  }
`
